import { render } from "./CustomerAddEdit.vue?vue&type=template&id=4638318d&scoped=true"
import script from "./CustomerAddEdit.vue?vue&type=script&lang=js"
export * from "./CustomerAddEdit.vue?vue&type=script&lang=js"

import "./CustomerAddEdit.vue?vue&type=style&index=0&id=4638318d&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4638318d"]])

export default __exports__